import { Loader2 } from 'lucide-react';

interface TextWritingNoteProps {
  /** Sections written so far. */
  done: number;
  /** Sections in the lesson (0 while unknown). */
  total: number;
}

/**
 * Shown under the lesson text while it is still being written: the text
 * arrives section by section, so the student can start reading at once.
 */
export function TextWritingNote({ done, total }: TextWritingNoteProps) {
  const label =
    total > 0
      ? `Writing section ${Math.min(done + 1, total)} of ${total}…`
      : 'Writing the next section…';
  return (
    <p
      role='status'
      aria-live='polite'
      className='mt-8 flex items-center gap-2 border-t border-border pt-4 text-sm text-muted-foreground'
    >
      <Loader2
        className='h-4 w-4 animate-spin motion-reduce:animate-none'
        aria-hidden
      />
      {label}
    </p>
  );
}
